import language from './Lang'
import message from './Message'
import otp from './Otp'
import country from './Country'
import testing from './Testing'

/* eslint-disable */
export default {
  language,
  message,
  otp,
  country,
  testing
}
/* eslint-enable */
